import moment from 'moment'
import store from '../../store'

export default {
    "title": "Press",
    "entityName": "press",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [



        {
            md: 3,
            "value": "type",
            "text": "Tipo",
            "type": "list",
            "list": ['Banner', 'Banner Generator', 'Comunicati', 'Dicono di noi', 'Focus on', 'Intervista'],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
            readonly: (item) => {
                return item.id && item.type ? true : false
            },
        },


        {
            md: 5,
            "value": "template_id",
            "text": "Template",
            "title": "name",
            "type": "autocomplete",
            // "readonly": item => { return item.id ? true : false },
            // "return_object": true,
            "validators": [
                // "required",
                (field, v, item) => { return item.type == 'Banner Generator' || !!v || !!item.id || `${field.text} is required` }
            ],
            deps: ['type'],
            filter: (item, search) => {
                let searchObj = { 'tag': "%" + item.type + "%" }
                if (search) {
                    searchObj['name'] = `%${search}%`
                }
                return searchObj
            },
            readonly: (item) => {
                return (item.template_id && item.id && item.type) ? true : false
            },
            // render: (item) => {
            //     return item.country.name + " (" + item.country.code + ")" 
            // },
        },

        {
            md: 4,
            "value": "department_id",
            "text": "Reparto",
            "title": "name",
            "type": "autocomplete",
            // "readonly": item => { return item.id ? true : false },
            // "return_object": true,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ],
            // render: (item) => {
            //     return item.country.name + " (" + item.country.code + ")" 
            // },
        },




        // {
        //     mini:true,
        //     "value": "name",
        //     "text": "Nome",
        //     "type": "text",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },
        //     "validators": [
        //     ],
        // },

        {
            md: 6,
            "value": "title",
            "text": "Titolo",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        {
            md: 6,
            "value": "subtitle",
            "text": "Sottotitolo",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
            ],
            deps: ['type'],
            readonly: (item) => {
                return item.type == 'Banner Gmail' || item.type == 'Banner Snippet'
            },
        },


        {
            md: 6,
            "value": "semantic_url",
            "text": "URL",
            "type": "text",
            appendIcon: (field, item) => { return item.semantic_url && (item.type == 'Focus on' || item.type == 'Intervista' || item.type == 'Banner Generator') ? "mdi-link" : null },
            clickAppend: (field, item) => {
                if (!item.semantic_url) {
                    return
                }
                if (item.type == 'Focus on') {
                    window.open(store.getters.siteUrl + '/focus-on-dettaglio/' + item.semantic_url, '_blank')
                }
                if (item.type == 'Intervista') {
                    window.open(store.getters.siteUrl + '/intervista-dettaglio/' + item.semantic_url, '_blank')
                }
                if (item.type == 'Banner Generator') {
                    window.open(item.semantic_url, '_blank')
                }
            },
            "validators": [
                // "required",
                (field, v, item) => { return !!v || item.type != 'Focus on' || `${field.text} is required` }
            ],
            deps: ['type'],
            readonly: item => item.type != 'Focus on' && item.type != 'Banner Generator',
        },



        {
            md: 6,
            "value": "static_page",
            "text": "Static Page",
            "type": "text",
            appendIcon: (field, item) => { return item.static_page ? "mdi-link" : null },
            clickAppend: (field, item) => {
                window.open(item.static_page, '_blank')
            },
            deps: ['type'],
            readonly: item => item.type != 'Focus on',
        },

        // {
        //     md:2,
        //     "value": "date",
        //     "text": "Data",
        //     "type": "date",
        //     "validators": [
        //         "required"
        //     ],
        //     deps:['type'],
        //     visible: item => ['Focus on', 'Intervista', 'Dicono di noi', 'Comunicati'].includes(item.type),
        // },


        // {
        //     slim:true,
        //     "value": "date",
        //     "text": "Date",
        //     "type": "date",
        //     // "readonly": item => { return item.id ? true : false },
        //     // "return_object": true,
        //     "validators": [
        //     ],
        //     // render: (item) => {
        //     //     return item.country.name + " (" + item.country.code + ")" 
        //     // },
        // },



        {
            md: 2,
            "value": "in_homepage",
            "text": "HomePage",
            "type": "check",
            deps: ['type'],
            readonly: (item) => {
                return item.type == 'Banner Generator'
            },
        },

        {
            md: 2,
            "value": "in_carousel",
            "text": "Carousel",
            "type": "check",
            deps: ['type'],
            readonly: (item) => {
                return item.type == 'Banner Generator'
            },
        },

        {
            md: 2,
            "value": "in_mediacenter",
            "text": "Mediacenter",
            "type": "check",
            deps: ['type'],
            readonly: (item) => {
                return item.type == 'Banner Generator'
            },
        },

        {
            md: 2,
            "value": "public",
            "text": "Public",
            "type": "check",
            deps: ['type'],
            // visible: (item) => item.type != 'Banner'
        },

        {
            md: 4,
            "value": "date",
            "text": "Date",
            "type": "date",
            "table": {
                "sortable": true,
                "filter": true
            },
            render: (item) => { return moment(item.date).format('DD/MM/YYYY') },
            filter: (filters, search) => { return { 'date': `>=${search}` } },
            "validators": [
                "required"
            ],
            deps: ['type'],
            visible: (item) => {
                return !(item.type == 'Banner' || item.type == 'Banner Generator')
            },
        },

        {
            md: 2,
            "value": "dateFrom",
            "text": "Date From",
            "type": "date",
            "table": {
                "sortable": true,
                "filter": true
            },
            // "validators": [
            //     "required"
            // ],
            deps: ['type'],
            visible: (item) => {
                return item.type == 'Banner' || item.type == 'Banner Generator'
            },
        },


        {
            md: 2,
            "value": "dateTo",
            "text": "Date To",
            "type": "date",
            "table": {
                "sortable": true,
                "filter": true
            },
            // "validators": [
            //     "required"
            // ],
            deps: ['type'],
            visible: (item) => {
                return item.type == 'Banner' || item.type == 'Banner Generator'
            },
        },



        {
            slim: true,
            "value": "country_id",
            "text": "Country",
            "title": "name",
            "type": "autocomplete",
            // "readonly": item => { return item.id ? true : false },
            // "return_object": true,
            "validators": [
                // "required",
                (field, v) => { return !!v || `${field.text} is required` }
            ],
            deps: ['type'],
            visible: (item) => {
                return item.type == 'Focus on'
            },
            // filter: (item, search) => {
            //     let searchObj = {'tag':"%" + item.type + "%"}
            //     if(search) {
            //         searchObj['name'] = `%${search}%`
            //     }
            //     return searchObj
            // },
            readonly: (item) => {
                return item.template_id && item.id && item.type ? true : false
            },
            // render: (item) => {
            //     return item.country.name + " (" + item.country.code + ")" 
            // },
        },


        {
            md: 12,
            "value": "image",
            "text": "Image",
            "type": "image",
        },


        {
            md: 12,
            "value": "banner_max_width",
            "text": "Banner max width",
            "type": "text",
            deps: ['type'],
            visible: (item) => item.type == 'Banner Generator',
            default: (item) => !item.id ? '100%' : item.banner_max_width
        },


        {
            full: true,
            "value": "datamap",
            "text": "Datamap",
            "title": "name",
            "type": "component",
            "name": "cms-datamap",
            deps: ['template_id'],
            "bind": (field) => {
                return {
                    entity: "press",
                    entityId: field.item.id,
                    clearDatamap: false
                }
            },
            visible: (item) => item.template_id
            // "readonly": item => { return item.id ? true : false },
            // "return_object": true,
            // render: (item) => {
            //     return item.country.name + " (" + item.country.code + ")" 
            // },
        },




    ],
    "actions": [
        {
            "value": "update", "text": "Edit", "icon": "mdi-pencil", "color": "primary",
        }
    ]
}